//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CartService } from "@nuskin/ns-shop";
import { events } from "@nuskin/ns-util";
import {
  getPersonalizedRecommendations,
  getRelatedProducts
} from "../services/NsProductRecommendationClient";
import NuHomeCloneProductCarousel from "./NuHomeCloneProductCarousel/NuHomeCloneProductCarousel.vue";

export default {
  name: "NsProductRecsCarousel",
  components: { NuHomeCloneProductCarousel },
  props: {
    title: {
      type: String,
      default: ""
    },
    productId: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      required: true
    },
    country: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      recommendedProductIds: [],
      productIdsToOmit: [],
      productsLimit: 10
    };
  },
  computed: {
    productIds() {
      // Filter out all products marked for omission
      return this.recommendedProductIds.filter(
        id => !this.productIdsToOmit.includes(id)
      );
    }
  },
  watch: {
    /**
     * @param {string | undefined} id
     */
    productId(id) {
      this.initRecommendations(id);
    }
  },
  created() {
    // When items are added to the cart, omit them from recommendations.
    events.subscribe(events.shop.CART_UPDATED, info => {
      if (info.add) {
        this.productIdsToOmit.push(info.add.item.sku);
      }
    });

    // Get the current status of the cart-data-sync process,
    // and subscribe to any further changes to that status.
    events.getValue(
      events.shop.CART_SYNCED_ON_LOAD,
      status => {
        // Abort if the cart hasn't been synced yet,
        // and wait for the next sync event.
        if (!status) return;

        // Cart data has been synced; get current cart contents and
        // set as the list of products to omit from recommendations.
        const cartItems = CartService.getItemData() || [];
        const cartSkus = cartItems.map(item => item.sku);
        this.productIdsToOmit = cartSkus;
      },
      true
    );
  },
  mounted() {
    this.initRecommendations(this.productId);
  },
  methods: {
    /**
     * @param {{
     * sku: string,
     * slug: string
     * }} pdpEvent
     */
    onClickPdp(pdpEvent) {
      // TODO: emit GTM event
      console.log("pdpEvent:", pdpEvent);
    },
    /**
     * @param {{
     * sku: string,
     * qty: number,
     * userId: string,
     * cntryCd: string,
     * isAdr: boolean,
     * referrer: string,
     * domain: string
     * }} atcEvent
     */
    onClickAddToCart(atcEvent) {
      // TODO: emit GTM event
      console.log("atcEvent", atcEvent);
    },
    /**
     * @param {string} [productId]
     */
    async initRecommendations(productId) {
      this.loading = true;

      try {
        let productIds = [];
        if (productId) {
          // Related Products mode
          productIds = await getRelatedProducts(productId, this.productsLimit);
        } else {
          // User-Personalized mode
          productIds = await getPersonalizedRecommendations(this.productsLimit);
        }
        this.recommendedProductIds = productIds;
      } catch (err) {
        console.error(err);
      }

      this.loading = false;
    }
  }
};
